import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

/** Bascule clair / sombre, calquée sur le sélecteur de langue. */
export default function ThemeSwitch({ className = "" }) {
  const { theme, setTheme } = useTheme();
  const options = [
    ["clair", Sun, "Clair / Light"],
    ["sombre", Moon, "Sombre / Dark"],
  ];
  return (
    <div className={`inline-flex items-center rounded-md border border-line-strong overflow-hidden ${className}`} data-testid="theme-switch">
      {options.map(([v, Icone, titre]) => (
        <button
          key={v}
          data-testid={`theme-${v}`}
          onClick={() => setTheme(v)}
          title={titre}
          aria-label={titre}
          aria-pressed={theme === v}
          className={`px-2.5 py-1.5 transition-colors ${
            theme === v ? "bg-brand text-white" : "text-ink-soft hover:bg-hover-strong hover:text-ink"
          }`}
        >
          <Icone className="h-3.5 w-3.5" />
        </button>
      ))}
    </div>
  );
}
